import React from 'react'
import BasicInfo from './components/BasicInfor'
import Education from './components/Education'
import Experience from './components/Experience'
import ProffessionalSummary from './components/ProffessionalSummary'
import UserSkills from './components/UserSkills'

const Profile: React.FC = () => {
  return (
    <div className='card mb-5 mb-xl-10'>
      <BasicInfo />
      <div className='separator mx-1 my-4'></div>
      <ProffessionalSummary />
      <div className='separator mx-1 my-4'></div>
      <UserSkills />
      <div className='separator mx-1 my-4'></div>
      <Education />
      <div className='separator mx-1 my-4'></div>
      <Experience />
    </div>
  )
}

export default Profile
